
import { Vue, Component, Watch } from "vue-property-decorator"
import api from "../honcierge-api"
import EditAppAffiliateTemplate from "@/components/EditAppAffiliateTemplate.vue"
import TableItemIsEnabled from "@/components/_share/TableItemIsEnabled.vue"
import { DataTableHeader } from "vuetify/types"
import { AppAffiliate, AppAffiliateTemplate } from "types/appAffiliate"
import { AxiosError } from "axios"

@Component({
  components: { EditAppAffiliateTemplate, TableItemIsEnabled },
})
export default class AppAffiliateTemplates extends Vue {
  private loading = true
  private dialog = false
  private searchName = ""
  private searchAdText = ""
  private totalPages = 0
  private selectedAppAffiliate?: AppAffiliate["data"]
  private appAffiliates: AppAffiliate["data"][] = []
  private appAffiliateTemplates: AppAffiliateTemplate["data"][] = []
  private pagination = {
    sortBy: ["id"],
    sortDesc: [true],
    itemsPerPage: -1,
    page: 1,
  }

  private isEnabledFilters: Array<{
    name: string
    isEnabled: "only_enabled" | "only_disabled" | "all"
  }> = [
    { name: "絞り込みなし", isEnabled: "all" },
    { name: "有効", isEnabled: "only_enabled" },
    {
      name: "無効(アプリアフィリエイトが無効も含む)",
      isEnabled: "only_disabled",
    },
  ]
  private selectedFilter: {
    name: string
    isEnabled: "only_enabled" | "only_disabled" | "all"
  } = { name: "有効", isEnabled: "only_enabled" }

  get headers(): DataTableHeader[] {
    return [
      { text: "ID", value: "id" },
      { text: "名前", value: "name" },
      { text: "ボタンテキスト", value: "adText" },
      { text: "アフィリエイトイベント", value: "appAffiliateName" },
      { text: "有効/無効", value: "isEnabled" },
      { text: "共有URL", value: "adUrl" },
      { text: "iOS URL", value: "adUrlIos" },
      { text: "Android URL", value: "adUrlAndroid" },
      { text: "操作", value: "action", sortable: false },
    ]
  }

  public created(): void {
    this.getAppAffiliates()
    this.loading = false
  }

  @Watch("pagination.page", { deep: true, immediate: true })
  private onChangePage() {
    this.loading = true
    this.getAppAffiliateTemplates()
  }

  private getAppAffiliates() {
    const name = ""
    const label = ""
    const sortBy = "id"
    const descending = true
    api
      .getAppAffiliates(name, label, "all", sortBy, descending, 1, 1000000)
      .then((response) => {
        this.appAffiliates = response.data.appAffiliates
      })
      .catch((error) => {
        this.$toasted.error(error.response.data.messages)
      })
  }

  private getAppAffiliateTemplates(page?: number) {
    api
      .getAppAffiliateTemplates(
        this.searchName,
        this.searchAdText,
        this.selectedFilter.isEnabled,
        this.selectedAppAffiliate ? this.selectedAppAffiliate.id : null,
        this.pagination.sortBy[0],
        this.pagination.sortDesc[0],
        page ? page : this.pagination.page,
        10,
        [
          "id",
          "name",
          "isEnabled",
          "adText",
          "adUrl",
          "adUrlIos",
          "adUrlAndroid",
        ],
        true
      )
      .then((res) => {
        this.totalPages = res.data.meta.totalPages
        this.appAffiliateTemplates.length = 0
        this.appAffiliateTemplates = res.data.appAffiliateTemplates
      })
      .catch((e: AxiosError) => {
        console.log(e.stack)
      })
      .finally(() => {
        this.loading = false
      })
  }

  private searchAppAffiliateTemplates() {
    this.resetPagination()
    this.getAppAffiliateTemplates()
  }

  private resetPagination() {
    this.pagination.page = 1
  }

  private updateAppAffiliateTemplate(
    appAffiliateTemplate: AppAffiliateTemplate["data"]
  ) {
    const target = this.appAffiliateTemplates.find(
      (c) => c.id === appAffiliateTemplate.id
    )
    if (target) {
      // 更新
      target.appAffiliate = appAffiliateTemplate.appAffiliate
      target.name = appAffiliateTemplate.name
      target.adText = appAffiliateTemplate.adText
      target.adUrl = appAffiliateTemplate.adUrl
      target.adUrlIos = appAffiliateTemplate.adUrlIos
      target.adUrlAndroid = appAffiliateTemplate.adUrlAndroid
      target.htmlArea = appAffiliateTemplate.htmlArea
      target.htmlAreaIos = appAffiliateTemplate.htmlAreaIos
      target.htmlAreaAndroid = appAffiliateTemplate.htmlAreaAndroid
      target.isHtmlOnly = appAffiliateTemplate.isHtmlOnly
      target.needExcuse = appAffiliateTemplate.needExcuse
      target.needExcusePr = appAffiliateTemplate.needExcusePr
    } else {
      // 新規作成
      this.getAppAffiliateTemplates()
    }
    this.close()
  }

  private async open(item?: AppAffiliateTemplate["data"]) {
    const editAppAffiliateTemplate = this.$refs
      .editAppAffiliateTemplate as InstanceType<typeof EditAppAffiliateTemplate>
    if (item) {
      // 更新
      editAppAffiliateTemplate.id = item.id
      try {
        const response = await api.getAppAffiliateTemplate(item.id)
        const appAffiliateTemplate: AppAffiliateTemplate["data"] =
          response.data.appAffiliateTemplate
        editAppAffiliateTemplate.appAffiliateId =
          appAffiliateTemplate.appAffiliate.id
        editAppAffiliateTemplate.name = appAffiliateTemplate.name
        editAppAffiliateTemplate.adText = appAffiliateTemplate.adText
        editAppAffiliateTemplate.isHtmlOnly = appAffiliateTemplate.isHtmlOnly
        editAppAffiliateTemplate.adUrl = appAffiliateTemplate.adUrl
        editAppAffiliateTemplate.adUrlIos = appAffiliateTemplate.adUrlIos
        editAppAffiliateTemplate.adUrlAndroid =
          appAffiliateTemplate.adUrlAndroid
        editAppAffiliateTemplate.htmlArea = appAffiliateTemplate.htmlArea
        editAppAffiliateTemplate.htmlAreaIos = appAffiliateTemplate.htmlAreaIos
        editAppAffiliateTemplate.htmlAreaAndroid =
          appAffiliateTemplate.htmlAreaAndroid
        editAppAffiliateTemplate.needExcuse = appAffiliateTemplate.needExcuse
        editAppAffiliateTemplate.needExcusePr =
          appAffiliateTemplate.needExcusePr
        editAppAffiliateTemplate.articles = appAffiliateTemplate.articles
      } catch (err) {
        this.$toasted.error(err.response.data.message)
        this.close()
      }
    } else {
      // 新規作成
      editAppAffiliateTemplate.init()
    }
    // 選択用のアフィリエイトリストを取得
    try {
      const name = ""
      const label = ""
      const sortBy = ""
      const descending = false
      const page = 1
      const per = 10000000
      const responseAppAffiliates = await api.getAppAffiliates(
        name,
        label,
        this.selectedFilter.isEnabled,
        sortBy,
        descending,
        page,
        per
      )
      editAppAffiliateTemplate.appAffiliates =
        responseAppAffiliates.data.appAffiliates
    } catch {
      this.$toasted.error("アフィリエイトの取得に失敗しました")
    }
    this.dialog = true
  }

  private close() {
    this.dialog = false
  }
}
